<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte novo blagajno:
    </h2>

    <DeviceForm
      @save="save"
      @cancel="cancel"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DeviceForm from '@/components/DeviceForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    DeviceForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    childCompanyId: {
      required: true,
      type: Number
    },
    businessUnitId: {
      required: true,
      type: Number
    }
  },
  methods: {
    ...mapActions('clientsDevices', ['saveItem']),
    save ({ data }) {
      this.saveItem({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId, item: data })
        .then(item => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          this.$router.push({ name: 'ClientsBusinessUnitsDevices', params: { childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId } })
        })
    },
    cancel () {
      this.$router.push({ name: 'ClientsBusinessUnitsDevices', params: { childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId } })
    }
  },
  created () {
    this.asyncDataStatus_fetched()
  }
}
</script>
